module.exports = __webpack_public_path__ + "static/img/libaozhongxin.0479911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/libaozhongxin.png
// module id = eIE+
// module chunks = 12